import { render } from "./ObjectNotEditableComponent.vue?vue&type=template&id=6e7e285c&lang=true"
import script from "./ObjectNotEditableComponent.vue?vue&type=script&lang=js"
export * from "./ObjectNotEditableComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__